import { Splitter, SplitterPanel } from "primereact/splitter";

import { themeClasses as T, C } from "sj-ui-toolkit/src/atlas/utils/themeClasses";

import LessonInfo from "./LessonInfo.jsx";
import Survey from "./Survey/Survey.jsx";

import S from "./_Lesson.module.scss";

const LessonCoverPage = ({
  headerText,
  onSubmit,
  description,
  lessonType,
  title,
  level,
  duration,
  isAfterLessonSurvey,
  hasNextLesson,
}) => {
  return (
    <Splitter className={C(T.splitterGap, "w-full h-full")}>
      <SplitterPanel size={30} minSize={20} className={C("flex flex-col max-h-full", S.leftPanel)}>
        <div>
          <LessonInfo
            lessonType={lessonType}
            title={title}
            description={description}
            level={level}
            duration={duration}
          />
        </div>
      </SplitterPanel>
      <SplitterPanel className="max-h-full" size={70} minSize={40}>
        <Survey
          headerText={headerText}
          onSubmit={onSubmit}
          description={description}
          isAfterLessonSurvey={isAfterLessonSurvey}
          hasNextLesson={hasNextLesson}
        />
      </SplitterPanel>
    </Splitter>
  );
};

export default LessonCoverPage;
